// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled-box[data-v-755df78c] .el-textarea__inner {\n  padding-left: 8px;\n}\n.total-time-con[data-v-755df78c] {\n  padding-top: 6px;\n  line-height: 1;\n}\n.total-time-con .text[data-v-755df78c] {\n  color: #939696;\n}\n.total-time-con .time[data-v-755df78c] {\n  color: #2F3030;\n}\n.show-label[data-v-755df78c] {\n  margin: 21px 0 15px -88px;\n}\n.show-label .text[data-v-755df78c] {\n  padding-right: 8px;\n}", ""]);
// Exports
module.exports = exports;
